import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, inject, bind, deepStringFind, StatusCard, DisplayEventProfile } from 'Mri.Web.Common';
import * as React from 'react';
import { Input } from 'reactstrap';
import { DisplayEventProfileItem } from '../../../DisplayEventProfiles/DisplayEventProfileItem';
import { AlertActionsStore } from '../../../DisplayAlerts/AlertActionsStore';

export interface IDisplayEventProfilesCardProps {
    readonly eventProfiles?: Mri.DisplayEventProfiles.DisplayEventProfile[];
    readonly alertActionsStore: AlertActionsStore;
}

@autoinject
@observer
export class DisplayEventProfilesCard extends React.Component<IDisplayEventProfilesCardProps> {
    public render() {
        return (
            <StatusCard title={this.getTitleView()}>
                <Input
                    type="text"
                    placeholder="Search Profiles..."
                    value={this.searchValue}
                    onChange={this.onSearchInputChange}
                    className="rounded-0 ticket-search"
                />

                <div className="scroll-container mt-3">
                    <div className="scroll-card">
                        <table className="w-100">
                            <tbody>
                                {this.eventProfiles?.map(p => (
                                    <DisplayEventProfileItem key={p.displayEventProfileGuid} displayEventProfile={p} />
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </StatusCard>
        );
    }

    @bind
    @action
    private onSearchInputChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        this.searchValue = target.value;
    }

    private getTitleView() {
        return this.warrantyEventProfiles && this.warrantyEventProfiles.length > 0
            ? 'Event Alerts and Automations (Warranty Alerts are Active)'
            : 'Event Alerts and Automations (Warranty Alerts are NOT Active)';
    }

    @computed
    private get eventProfiles() {
        let eventProfiles = this.props.eventProfiles;
        const alertActionsStore = this.props.alertActionsStore;

        // Want to include all automations and all alerts except warranty alerts
        if (eventProfiles) {
            eventProfiles = eventProfiles.filter(
                p =>
                    !(
                        p.alertActionGuid != undefined &&
                        alertActionsStore.alertActions
                            .get(p.alertActionGuid)
                            ?.actionRecipients.find(ar => ar.type == Mri.DisplayAlerts.RecipientType.AccountSubscribers)
                    )
            );

            if (this.searchValue) eventProfiles = eventProfiles.filter((o: any) => deepStringFind(o, this.searchValue));
        }
        return eventProfiles;
    }

    @observable
    private searchValue: string = '';

    @computed
    private get warrantyEventProfiles() {
        const eventProfiles = this.props.eventProfiles;
        const alertActionsStore = this.props.alertActionsStore;

        // Want to include all automations and all alerts except warranty alerts
        if (eventProfiles) {
            return eventProfiles.filter(
                p =>
                    p.alertActionGuid != undefined &&
                    alertActionsStore.alertActions
                        .get(p.alertActionGuid)
                        ?.actionRecipients.find(ar => ar.type == Mri.DisplayAlerts.RecipientType.AccountSubscribers)
            );
        }
    }
}
